const blockReviews = (Swiper, Navigation, Pagination, Autoplay) => {
	const wrapReviews = document.querySelectorAll('.js-reviews-slider');
	const seeMoreText = document.querySelectorAll('.js-see-all-review');

	if (wrapReviews) {
		wrapReviews.forEach((wrapRev) => {
			let swiperReview = wrapRev.querySelector('.s-review__swiper');
			const arrowPrev = wrapRev.querySelector('.c-swiper-single-arrow.c-swiper-single-arrow--prev');
			const arrowNext = wrapRev.querySelector('.c-swiper-single-arrow.c-swiper-single-arrow--next');

			if (swiperReview) {
				swiperReview = new Swiper(swiperReview, {
					slidesPerView: 1,
					spaceBetween: 75,
					modules: [Navigation, Pagination, Autoplay],
					navigation: {
						nextEl: arrowNext,
						prevEl: arrowPrev,
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
						992: {
							slidesPerView: 3,
						},
						1200: {
							slidesPerView: 3,
						},
						1400: {
							slidesPerView: 4,
						},
					},
				});
			}
		});
	}

	if (seeMoreText) {
		seeMoreText.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.currentTarget.parentElement.classList.add('see-all');
				e.currentTarget.classList.add('hidden');
			});
		});
	}

	// swiperReview.on('slideChange', () => {
	//   console.log(swiperReview.activeIndex);
	//   const prevBtn = document.querySelectorAll(
	//     '.c-swiper-single-arrow--review.c-swiper-single-arrow--prev',
	//   );
	//   const nextBtn = document.querySelectorAll(
	//     '.c-swiper-single-arrow--review.c-swiper-single-arrow--next',
	//   );
	//   if (swiperReview.activeIndex === 1) {
	//     prevBtn.forEach((el) => {
	//       el.classList.remove('c-swiper-single-arrow--prev-review-off');
	//     });
	//   }
	//   if (swiperReview.activeIndex === 0) {
	//     prevBtn.forEach((el) => {
	//       el.classList.add('c-swiper-single-arrow--prev-review-off');
	//     });
	//   }
	//   if (swiperReview.isEnd) {
	//     nextBtn.forEach((el) => {
	//       el.classList.add('c-swiper-single-arrow--prev-review-off');
	//     });
	//   }
	//   if (!swiperReview.isEnd) {
	//     nextBtn.forEach((el) => {
	//       el.classList.remove('c-swiper-single-arrow--prev-review-off');
	//     });
	//   }
	// });
};

export default blockReviews;
